// @ts-nocheck
import React from 'react';
import notification from 'antd/lib/notification';
import { applyMaskToValue, declineNumber } from './../../../lib/helpers';
import { notificationLoading } from '../../../components/Notifications';
import { reportArchiveVehiclesApi } from '../../../lib/api';
import Header from '../../../components/layout/Header';
import { Table } from '../../../components/ant/table/Table';
import { PageFlexColumnWrapper, TableFlexColumnWrapper } from '../../../components/ant/table/Wrappers';
import { formatLicensePlateMask } from '../../../components/inputs/masked-inputs/LicensePlateInput';
import Filter from './components/Filter';
const initialParams = {};
/**
 * Отчет о рекомендуемых к списанию/замене ТС
 */
export class ArchiveVehiclesList extends React.Component {
  state = {
    params: initialParams,
    data: [],
    loading: false,
    scrollY: window.innerHeight - 450
  };
  handleChangeFilter = (key, value) => {
    this.setState(prevState => ({
      params: {
        ...prevState.params,
        [key]: value
      }
    }));
  };
  async componentDidMount() {
    await this.fetchReportArchiveVehicles();
  }
  fetchReportArchiveVehicles = async () => {
    try {
      this.setState({
        loading: true
      });
      const data = await reportArchiveVehiclesApi.fetchReportArchiveVehicles(this.state.params);
      this.setState({
        data
      });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      this.setState({
        loading: false
      });
    }
  };
  applyParams = this.fetchReportArchiveVehicles;
  cleanParams = () => this.setState({
    params: initialParams
  });
  handleExport = async () => {
    try {
      notificationLoading({
        message: 'Формирование файла для печати',
        key: 'print'
      });
      await reportArchiveVehiclesApi.printReportArchiveVehicles(this.state.params);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('print');
    }
  };
  columns = [{
    title: 'Тип ТС',
    dataIndex: 'vehicleType',
    width: 100,
    render: type => type
  }, {
    title: 'Гос. номер',
    dataIndex: 'licensePlate',
    width: 150,
    render: licensePlate => licensePlate && applyMaskToValue(licensePlate, formatLicensePlateMask)
  }, {
    title: 'Марка ТС',
    width: 100,
    dataIndex: 'brandName'
  }, {
    title: 'Подразделение',
    width: 150,
    dataIndex: 'orgUnitName'
  }, {
    title: 'Возраст',
    width: 100,
    dataIndex: 'vehicleAge',
    render: vehicleAge => `${vehicleAge} ${declineNumber(vehicleAge, 'год', 'года', 'лет')}`
  }, {
    title: 'Пробег',
    width: 100,
    dataIndex: 'kilometrage',
    render: kilometrage => `${kilometrage} км.`
  }, {
    title: 'Количество маш/часов',
    width: 100,
    dataIndex: 'engineWorkHours',
    render: workTime => `${workTime} ч.`
  }];
  render() {
    const {
      loading,
      data,
      scrollY
    } = this.state;
    return <PageFlexColumnWrapper>
        <Header left={<h1>Отчет о рекомендуемых к списанию/замене ТС</h1>} />
        <TableFlexColumnWrapper>
          <Filter params={this.state.params} onChangeFilter={this.handleChangeFilter} applyParams={this.applyParams} cleanParams={this.cleanParams} onExport={this.handleExport} />
          <Table loading={loading} rowKey="vehicleId" pagination={false} dataSource={data} columns={this.columns} name="ReportsArchiveVehicles" flags={['useNewStyle']} customStyle={{
          overflowY: undefined,
          overflowX: undefined
        }} customScroll={{
          y: scrollY,
          x: 1500
        }} />
        </TableFlexColumnWrapper>
      </PageFlexColumnWrapper>;
  }
}
export default ArchiveVehiclesList;
